import client from 'lib/api/client';

export const getDashboardCount = () => client.get(`/dashboard`);

export const getNotiCheck = () => client.get(`/dashboard/count`);

export const getDashboardRegisterList = (registerType, page) =>
  client.get(`/dashboard/list/${registerType}?page=${page}&limit=10`);
